export default __webpack_public_path__ + "static/media/sentra.3130555f.jpg";